import { popupService } from '../../services/helperServices/PopupService';
import {
  BONUS_TICKET_TYPE,
  BONUS_TOTAL_ODD,
  BONUS_WIN_STATE,
  FREE_SPIN_COUNT_STATE,
  GAME_APPLICATION_TYPE_STATE,
  MULTIPLIER_STATE,
} from '../../stateManagment';
import { bonusInfoByTicketType } from '../../core/constats';
import { GameApplicationType } from '../../core/enums';

const isWeb = () => GAME_APPLICATION_TYPE_STATE.getValue() === GameApplicationType.web;

export const onDragStart = (event, self, parent) => {
  event.stopPropagation();
  if (isWeb()) {
    return;
  }
  self.draggingConfig.data = event.data;
  self.draggingConfig.startX = self.draggingConfig.data.getLocalPosition(parent).x;
  self.draggingConfig.dragging = true;
};

export const onDragEnd = (event, self) => {
  event.stopPropagation();
  if (isWeb()) {
    return;
  }
  self.draggingConfig.data = null;
  self.draggingConfig.startX = null;
  self.draggingConfig.dragging = false;
};

export const onDragMove = (event, self, parent) => {
  event.stopPropagation();
  if (isWeb()) {
    return;
  }
  if (self.draggingConfig.dragging) {
    const newPosition = self.draggingConfig.data.getLocalPosition(parent);
    self._moveElementsByDifference((newPosition.x - self.draggingConfig.startX) / 60);
  }
};

export const onCenterDown = (event, self, { parent, texture }) => {
  const { ticketType } = texture.parent;
  BONUS_TICKET_TYPE.next(ticketType)
  if (isWeb()) {
    if (texture.parent.ticketType === undefined) {
      return;
    }
      popupService.toggleBuyBonusPopupConfirmState();
    if (bonusInfoByTicketType[ticketType]) {
      const [freeSpin, multiplier] = bonusInfoByTicketType[ticketType];
      BONUS_TOTAL_ODD.next(1)
      BONUS_WIN_STATE.next(0)
      FREE_SPIN_COUNT_STATE.next(freeSpin);
      MULTIPLIER_STATE.next(multiplier);
    }
    return;
  }
  self.clickConfig.startX = event.data.getLocalPosition(parent).x;
  self.active_texture = texture

};

export const onCenterUp = (event, self, { parent, texture }) => {
  if (isWeb()) {
    return;
  }
  const x = event.data.getLocalPosition(parent).x;
  if (self.active_texture) {
    const [leftContainer, centerContainer, rightContainer] = self.containers;
    const left = leftContainer.children[2];
    const center = centerContainer.children[2];
    const right = rightContainer.children[2];

    if (texture === center) {
      if (x === self.clickConfig.startX || Math.abs(x - self.clickConfig.startX) >= 20) {
        popupService.toggleBuyBonusPopupConfirmState();
        if (bonusInfoByTicketType[centerContainer.ticketType]) {
          const [freeSpin, multiplier] = bonusInfoByTicketType[centerContainer.ticketType];
          FREE_SPIN_COUNT_STATE.next(freeSpin);
          MULTIPLIER_STATE.next(multiplier);
        }
      }
    } else if (texture === right) {
      self._slideLeft();
    } else if (texture === left) {
      self._slideRight();
    }
    self.active_texture = null;
  }
};

export const handlePointerover = (event, { active, normal }) => {
  active.alpha = 1;
  normal.alpha = 0;
};

export const handlePointerout = (event, { active, normal }) => {
  normal.alpha = 1;
  active.alpha = 0;
};
